
<template>
    
        <mars-view class="steps"><mars-view v-for="item, index in stepsData" :key="index" :class="['steps-item', index + 1 === curStep ? 'active' : '', index + 1 < curStep ? 'ok' : '']"><mars-view class="icon-bg"><mars-view class="icon" :class="['icon-' + (index + 1)]"></mars-view></mars-view><mars-view class="text">
            {{ item }}
        </mars-view><mars-view v-if="index !== stepsData.length - 1" :class="['line', 'line-' + index]"></mars-view></mars-view></mars-view>
    
</template>

<script>
export default {
  data() {
    return {
      stepsData: ['提交申请', '律师审核', '反馈结果']
    };
  },
  props: {
    // 当前在第几步,1,2,3,4。4：即三步都完成
    curStep: {
      type: Number,
      default: 1
    }
  }
};
</script>

<style scoped>
.steps {
  display: flex;
  padding: 0.22rem 0.34rem 0.2rem;
  justify-content: space-between;
  z-index: 1;
  position: relative;
}
.steps .steps-item .icon-bg {
  width: 0.32rem;
  margin: 0 auto;
  height: 0.32rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/icon-bg.png') no-repeat center center / 100% 100%;
}
.steps .steps-item .icon-bg .icon {
  height: 100%;
  width: 100%;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/icon-1.png') no-repeat center center / 100% 100%;
}
.steps .steps-item .icon-bg .icon.icon-2 {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/icon-2.png');
}
.steps .steps-item .icon-bg .icon.icon-3 {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/icon-3.png');
}
.steps .steps-item .text {
  font-family: PingFangSC-Medium;
  font-size: 0.14rem;
  color: #1f1f1f;
  line-height: 1;
  font-weight: 500;
  margin-top: 0.12rem;
  opacity: 0.5;
}
.steps .steps-item .line {
  width: 0.77rem;
  height: 0.03rem;
  position: absolute;
  top: 38%;
  opacity: 0.3;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/line-active.png') no-repeat center center / 100% 100%;
}
.steps .steps-item .line.line-0 {
  left: 23.5%;
}
.steps .steps-item .line.line-1 {
  left: 58.5%;
}
.steps .steps-item.active .icon-bg {
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/icon-bg-active.png') no-repeat center center / 100% 100%;
}
.steps .steps-item.active .icon-bg .icon-1 {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/icon-1-active.png');
}
.steps .steps-item.active .icon-bg .icon-2 {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/icon-2-active.png');
}
.steps .steps-item.active .icon-bg .icon-3 {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/icon-3-active.png');
}
.steps .steps-item.active .text {
  opacity: 1;
}
.steps .steps-item.active .line {
  opacity: 0.5;
}
.steps .steps-item.ok .text {
  opacity: 1;
}
.steps .steps-item.ok .icon {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/ok-icon.png') !important;
}

</style>
